import React from 'react';
import FieldGenerico from '../componentes_generales/componentes_formulario/fields/fieldgenerico';
import FieldDate from '../componentes_generales/componentes_formulario/fields/fielddate/fielddate';
import FieldSelect from '../componentes_generales/componentes_formulario/fields/fieldselect/fieldselect';
import FieldSelectAsync from '../componentes_generales/componentes_formulario/fields/fieldselect/fieldselectasync';
import FieldBusqEspecifica from '../componentes_generales/componentes_formulario/fields/busqueda_especifica/fieldselectasync-busq-especif';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit} from '../componentes_generales/componentes_formulario/contenedores/';
import { Label, LabelRadio } from '../componentes_generales/componentes_formulario/labels/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { Field, reduxForm, formValueSelector, getFormValues } from 'redux-form';
import { cargarCatalogos, cargarCatalogosAsync, cargarCatalogosGenericoAsync, cargarCatalogoEstados } from '../../funciones_globales/catalogos';
import { cargar_Articulo, cargar_ValoresIniciales, cambiarArancelDeArticulo } from '../../actions/inventario/act_inven01';
import { connect } from 'react-redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import global_axios from '../../funciones_globales/interaccionapi';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { validarPermisoAcceso, validarJSON, esNumero, validarCampoString } from '../../funciones_globales/utils';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

const validate = values => {
  const errors = {}
  if (!values.codigo) {
    errors.codigo = 'Campo requerido'
  } 
  if (!values.descripcion) {
    errors.descripcion = 'Campo requerido'
  } 
  if (!values.referencia) {
    errors.referencia = 'Campo requerido'
  }  
  if (!values.marca) {
    errors.marca = 'Campo requerido'
  }  
  if (!values.sublinea1) {
    errors.sublinea1 = 'Campo requerido'
  }  
  if (!values.tipocompra) {
    errors.tipocompra = 'Campo requerido'
  }
  if (!values.procedencia) {
    errors.procedencia = 'Campo requerido'
  }  
  if (!values.proveedor) {
    errors.proveedor = 'Campo requerido'
  }  
  if (!values.fecharegistro) {
    errors.fecharegistro = 'Campo requerido'
  }
  if (!values.fechavencimiento) {
    errors.fechavencimiento = 'Campo requerido'
  }
  if (!values.empaque) {
    errors.empaque = 'Campo requerido'
  }
  if (!values.estado) {
    errors.estado = 'Campo requerido'
  }
  if (values.unidporcaja===undefined || values.unidporcaja===null) {
    errors.unidporcaja = 'Campo requerido'
  }else{
    if (!esNumero(values.unidporcaja)) {
      errors.unidporcaja = 'Valor inválido'
    }
  }
  if (!values.arancel) {
    errors.arancel = 'Campo requerido'
  }
  if (!validarCampoString(values.peso, 1, 5)) {
    errors.peso = 'Campo requerido'
  }else{
    if (!esNumero(values.peso)) {
      errors.peso = 'Valor inválido'
    }
  }   
  if (validarCampoString(values.preciodistribuidor, 1, 10)) {
    if (!esNumero(values.preciodistribuidor)) {
      errors.preciodistribuidor = 'Valor inválido'
    }else{
      if(parseFloat(values.preciodistribuidor).toFixed(2)<0){
        errors.preciodistribuidor = 'Valor inválido'
      }
    }
  }
  if (validarCampoString(values.preciomayorista, 1, 10)) {
    if (!esNumero(values.preciomayorista)) {
      errors.preciomayorista = 'Valor inválido'
    }else{
      if(parseFloat(values.preciomayorista).toFixed(2)<0){
        errors.preciomayorista = 'Valor inválido'
      }
    }
  }
  if (validarCampoString(values.preciodetallista,1, 10)) {
    if (!esNumero(values.preciodetallista)) {
      errors.preciodetallista = 'Valor inválido'
    }else{
      if(parseFloat(values.preciodetallista).toFixed(2)<0){
        errors.preciodetallista = 'Valor inválido'
      }
    }
  }
  if (validarCampoString(values.pvp, 1, 10)) {
    if (!esNumero(values.pvp)) {
      errors.pvp = 'Valor inválido'
    }else{
      if(parseFloat(values.pvp).toFixed(2)<0){
        errors.pvp = 'Valor inválido'
      }
    }
  }
  if (validarCampoString(values.descuento, 1, 3)) {
    if (!esNumero(values.descuento)) {
      errors.descuento = 'Valor inválido'
    }else{
      if(parseFloat(values.descuento).toFixed(2)<0 || parseFloat(values.descuento).toFixed(2)>100){
        errors.descuento = 'Valor inválido'
      }
    }
  }
  if (!values.caracteristica) {
    errors.caracteristica = 'Campo requerido'
  }
  return errors
}

class FormInven01 extends React.Component{   
  constructor(props) {
    super(props);
    this.state = {
      lineas: [],
      medidas: [],
      status: [],
      operacion: 'G',
      columnDefs: [ {   header: "No.",
                        field: "nro",
                        width: 40,
                        type: "string"
                    },
                    {   header: "Cód. Artículo",
                        field: "codArt",
                        width: 130,
                        type: "string" 
                    },
                    {   header: "Nombre",
                        field: "nombArt",
                        width: 320,
                        type: "string"
                    },
                    {   header: "Marca",
                        field: "marcaArt",
                        width: 200,
                        type: "string"
                    },
                    {   header: "País Origen",
                        field: "paisOrigen",
                        width: 150,
                        type: "string"                        
                    },
                    {   header: "Es Principal",
                        field: "esPrincipal",
                        width: 80,
                        type: "string"
                    },
                    
                  ],      
    };
    this.gridOptions = {
      enableColResize: true
    };
    this.onGridReady = this.onGridReady.bind(this);
    this.inicializarComponentes = this.inicializarComponentes.bind(this);
  };
  
  onGridReady(params) {
    this.api = params.api;
    this.columnApi = params.columnApi;
  }

  inicializarComponentes(){
    this.props.reset();
    let fechaProceso = getFechaProcesoPorModulo('02');
    this.props.cargar_ValoresIniciales(fechaProceso);
    this.setState({ operacion: 'G'});
  }

  submit(e){
    let peso = null,      
        preciodistribuidor = null,
        preciomayorista = null,
        preciodetallista = null,
        pvp = null,
        descuento = null;

    if (validarCampoString(e.peso, 1, 5)){
      if(e.peso.toString().trim().length >= 0){
        peso = e.peso;
      }
    }    
    if (validarCampoString(e.preciodistribuidor,1, 10)){
      if(e.preciodistribuidor.toString().trim().length >= 0){
        preciodistribuidor = e.preciodistribuidor;
      }
    }
    if (validarCampoString(e.preciomayorista, 1, 10)){
      if(e.preciomayorista.toString().trim().length >= 0){
        preciomayorista = e.preciomayorista;
      }
    }
    if (validarCampoString(e.preciodetallista, 1, 10)){
      if(e.preciodetallista.toString().trim().length >= 0){
        preciodetallista = e.preciodetallista;
      }
    }
    if (validarCampoString(e.pvp, 1, 10)){
      if(e.pvp.toString().trim().length >= 0){
        pvp = e.pvp;
      }
    }
    if (validarCampoString(e.descuento, 1, 3)){
      if(e.descuento.toString().trim().length >= 0){
        descuento = e.descuento;
      }
    }
    
    let articulo = {
      ...e,
      peso,
      preciodistribuidor,
      preciomayorista,
      preciodetallista,
      pvp,
      descuento,
      codigo: e.codigo.toString().toUpperCase().trim(),
      descripcion: e.descripcion.toString().toUpperCase().trim(),
      marca: e.marca.value,
      sublinea1: e.sublinea1.value,
      sublinea2: (validarJSON(e.sublinea2)?e.sublinea2.value:null),
      tipocompra: e.tipocompra.value,
      procedencia: e.procedencia.value,
      proveedor: e.proveedor.value,
      usuario: getItemDatosSesion('usuario'),
      idRegAudit: this.props.idRegAudit
    };

    let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
    if (!validPermiso.esValido){
      alert(validPermiso.msg);
      return;
    }

    this.props.cambiar_VisualizacionLoading(true);

    global_axios({
      method: (this.state.operacion==='G')?'POST':'PUT',
      url: (this.state.operacion==='G')?'/articulos':'/articulos/' + e.codigo,
      data: articulo
    })
    .then((response)=> {
      this.props.cambiar_VisualizacionLoading(false);
      alert('El artículo: ' + articulo.codigo.toString().toUpperCase() + ' se ' + (this.state.operacion==='G'?' registró':' actualizó') + ' correctamente.');
      this.inicializarComponentes();
    })
    .catch((error)=>{
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  componentDidMount() {
    Promise.all([
        cargarCatalogos('FORMA'),
        cargarCatalogos('MEDIDA'),
        cargarCatalogoEstados('Articulo', 'Status'),
        this.props.generar_LogAuditoriaIngresoForm('0201')
    ])
    .then(([result_lineas, result_medidas, result_status]) => {
      this.setState(
        { lineas: result_lineas,
          medidas: result_medidas,
          status: result_status
        });
      let fechaProceso = getFechaProcesoPorModulo('02');
      this.props.cargar_ValoresIniciales(fechaProceso);
    })
    .catch(error => {
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0201');
  }
  
  getOptions_Marcas(input, callback){
    if (input.toString().length >= 2 ){
      cargarCatalogosAsync('LINEA', input, callback)
    }
  }

  getOptions_Sublineas(input, callback){
    if (input.toString().length >= 2 ){
      cargarCatalogosAsync('SUBLINEA', input, callback)
    }
  }
  
  getOptions_TiposCompra(input, callback){
    if (input.toString().length >= 2 ){
      cargarCatalogosAsync('TIPOPRECIO', input, callback)
    }
  }  

  getOptions_Procedencias(input, callback){
    if (input.toString().length >= 2 ){
      cargarCatalogosAsync('GRUPO', input, callback)
    }
  }  

  getOptions_Articulos(input, callback){
    if (input.toString().length >= 3 ){
      let query = "?tipo=catalogo&cadena_busq=" + input;     
      cargarCatalogosGenericoAsync('/articulos', query, callback)
    }
  }

  getOptions_Proveedores(input, callback){
    if (input.toString().length >= 3 ){
      let cadena_busq = "?tipo=catalogo&cadena_busq=" + input;
      cargarCatalogosGenericoAsync('/proveedores', cadena_busq, callback)  
    }
  }

  getArticulo(){
    if (this.props.codigo_articulo === undefined){
      alert('Ud. no ha seleccionado el artículo que desea consultar/editar.');
    }else{
      this.props.cargar_Articulo(this.props.codigo_articulo.value)
      .then(()=>{
        this.setState({operacion: 'M'});
      });
    }
  }
  
  render(){
      const { handleSubmit, submitting, initialValues } = this.props      

      let articulosSustituibles = [];

      if (initialValues !== null && initialValues !== undefined){
        if ( initialValues.articulosSustituibles !== undefined){
          initialValues.articulosSustituibles.forEach((artSust,i)=>{
            articulosSustituibles.push({
              nro: (i+1),
              codArt: artSust.Articulo,
              nombArt: artSust.NombArt,
              marcaArt: artSust.Marca,
              paisOrigen: artSust.Origen,
              esPrincipal: (artSust.EsPrincipal?'*':'')
            });
          });
        }
      }

        return(
          <ContenedorForm porc_ancho={70}>
            <HeaderForm>
              <TituloForm>Registro/Actualización de Artículo</TituloForm>
            </HeaderForm>
            <CuerpoForm>
              <ContainerEdit>
                <Row>
                  <div className='col-md-6'>
                    <Field
                      label="Cód. Artículo:"
                      name="articulo"
                      component={ FieldBusqEspecifica }
                      loadOptions={this.getOptions_Articulos.bind(this)}
                      getItemEspecifico={this.getArticulo.bind(this)}
                      func_OnFocus={this.inicializarComponentes}
                      textoBoton="Sel."
                      icono="fa fa-check-circle-o"/>
                  </div>
                </Row>
              </ContainerEdit>
              <form onSubmit={handleSubmit(this.submit.bind(this))}>
                <Row>
                  <div className='col-md-2'>
                    <Field
                      name="codigo"
                      type="text"
                      component={ FieldGenerico }
                      mayusculas={ true }
                      readonly={(this.state.operacion==='M')}
                      label="Código:"/>
                  </div>
                  <div className='col-md-5'>
                    <Field
                      name="descripcion"
                      type="text"
                      component={ FieldGenerico }
                      mayusculas={ true }
                      label="Descripción:"/>
                  </div>
                  <div className='col-md-2'>
                    <Field
                      name="referencia"
                      type="text"
                      component={ FieldGenerico }
                      label="Nro. de Parte:"/>
                  </div>
                  <div className='col-md-3'>
                    <Field
                      name="marca"
                      component= { FieldSelectAsync }
                      label="Marca:"
                      loadOptions={ this.getOptions_Marcas.bind(this) }/>
                  </div>
                </Row>              
                <Row>
                  <div className='col-md-4'>
                    <Field
                      name="linea"
                      component= { FieldSelect }                      
                      label="Línea:"
                      options={ this.state.lineas }/>
                  </div>  
                  <div className='col-md-4'>
                    <Field
                      name="sublinea1"
                      component= { FieldSelectAsync }
                      label="Sub-Línea 1:"
                      loadOptions={ this.getOptions_Sublineas.bind(this) }/>
                  </div>  
                  <div className='col-md-4'>
                    <Field
                      name="sublinea2"
                      component= { FieldSelectAsync }
                      label="Sub-Línea 2:"
                      loadOptions={ this.getOptions_Sublineas.bind(this) }/>
                  </div>  
                </Row>
                <Row>
                  <div className='col-md-4'>
                    <Field
                      name="tipocompra"
                      component= { FieldSelectAsync }
                      label="Categoría:"
                      loadOptions={ this.getOptions_TiposCompra.bind(this) }/>
                  </div>  
                  <div className='col-md-4'>
                    <Field
                      name="procedencia"
                      component= { FieldSelectAsync }
                      label="Procedencia:"
                      loadOptions={ this.getOptions_Procedencias.bind(this) }/>
                  </div>  
                  <div className='col-md-4'>
                    <Field
                      name="proveedor"
                      component= { FieldSelectAsync }
                      label="Proveedor:"                      
                      loadOptions={ this.getOptions_Proveedores.bind(this) }/>
                  </div>  
                </Row>
                <Row>
                  <div className='col-md-2'>
                    <Field
                      name="fecharegistro"
                      component={ FieldDate }                     
                      label="Fecha de Registro:"
                      placeholder="dd/mm/aaaa"
                      readOnly={true}/>
                  </div>
                  <div className='col-md-2'>
                    <Field
                      name="fechavencimiento"
                      component={ FieldDate }
                      label="Fecha de Vcto.:"
                      placeholder="dd/mm/aaaa"
                      readOnly={true}/>                      
                  </div>
                  <div className='col-md-4'>
                    <Field
                      name="empaque"
                      component= { FieldSelect }
                      label="Empaque:"
                      options={ this.state.medidas }/>
                  </div> 
                  <div className='col-md-2'>
                    <Field
                      name="estado"
                      component= { FieldSelect }
                      disabled = { this.state.operacion==='G'?true:false}
                      label="Estado:"
                      options={this.state.status}/>
                  </div>
                  <div className='col-md-2'>
                    <Field
                      name="unidporcaja"
                      type="text"
                      component={ FieldGenerico }
                      label="Unid. por Caja:"/>
                  </div>
                </Row>
                <Row>
                  <div className='col-md-2'>
                    <Field
                      name="arancel"
                      type="text"
                      component={ FieldGenerico }
                      label="Arancel:"
                      func_OnBlur={()=>{this.props.cambiarArancelDeArticulo(this.props.articuloValues, this.props.codigo_arancel)}}/>
                  </div> 
                  <div className='col-md-2'>
                    <Field
                      name="impuesto"
                      type="text"
                      component={ FieldGenerico }
                      label="% Impuesto:"
                      readonly={true}/>
                  </div>                  
                  <div className='col-md-2'>
                    <Field
                      name="salvaguardia"
                      type="text"
                      component={ FieldGenerico }
                      label="Salvaguardia:"
                      readonly={true}/>
                  </div>
                  <div className='col-md-2'>
                    <Field
                      name="coeficiente"
                      type="text"
                      component={ FieldGenerico }
                      label="Coeficiente:"
                      readonly={true}/>
                  </div>
                  <div className='col-md-2'>
                    <Field
                      name="peso"
                      type="text"
                      component={ FieldGenerico }
                      label="Peso (kg):"/>
                  </div>
                  <div className='col-md-2'>
                    <Field
                      name="costopromedio"
                      type="text"
                      component={ FieldGenerico }
                      readonly={true}
                      label="Costo Promedio:"/>
                  </div>           
                </Row>
                <Row>
                  <div className='col-md-2'>
                    <Field
                      name="preciodistribuidor"
                      type="text"
                      component={ FieldGenerico }
                      readonly={true}
                      label="Precio Distribuidor:"/>
                  </div>
                  <div className='col-md-2'>
                    <Field
                      name="preciomayorista"
                      type="text"
                      component={ FieldGenerico }
                      readonly={true}
                      label="Precio Mayorista:"/>
                  </div>
                  <div className='col-md-2'>
                    <Field
                      name="preciodetallista"
                      type="text"
                      component={ FieldGenerico }
                      readonly={true}
                      label="Precio Detallista:"/>
                  </div>
                  <div className='col-md-2'>
                    <Field
                      name="pvp"
                      type="text"
                      component={ FieldGenerico }
                      readonly={true}
                      label="Precio Vta. Público:"/>
                  </div>
                  <div className='col-md-2'>
                    <Field
                      name="descuento"
                      type="text"
                      component={ FieldGenerico }
                      readonly={true}
                      label="% Descuento:"/>
                  </div>
                  <div className='col-md-2'>
                    <Label>Grava Iva:</Label>
                      <Field
                        name="gravaiva"
                        component="input"
                        type="checkbox"/>
                  </div>                  
                </Row>
                <Row>
                  <div className='col-md-5'>
                    <Field
                      name="caracteristica"
                      type="text"
                      component={ FieldGenerico }
                      label="Vehículos aplica:"/>
                  </div>
                  <div className='col-md-1'>
                    <Label>Especial:</Label>
                      <Field
                        name="especial"
                        component="input"
                        type="checkbox"/>
                  </div>
                  <div className='col-md-1'>
                    <Label>Promoc.:</Label>
                      <Field
                        name="promocion"
                        component="input"
                        type="checkbox"/>
                  </div>
                  <div className='col-md-2'>
                    <Label>Nivel de Rotación:</Label>
                    <LabelRadio>
                      <Field
                        name="nivelrotacion"
                        component="input"
                        type="radio"
                        value="A"
                      /> A
                    </LabelRadio>
                    <LabelRadio>
                      <Field
                        name="nivelrotacion"
                        component="input"
                        type="radio"
                        value="B"
                      /> B
                    </LabelRadio>
                    <LabelRadio>
                      <Field
                        name="nivelrotacion"
                        component="input"
                        type="radio"
                        value="C"
                      /> C
                    </LabelRadio>
                  </div>                  
                  <div className='col-md-3'>
                    <Field
                      name="numpartesustitucion"
                      type="text"
                      component={ FieldGenerico }
                      label="Nro. de Parte (Sustitutos):"/>
                  </div>
                </Row>
                <Row>
                  <div className='col-md-2'>
                    <Field
                      name="ubicacion"
                      type="text"
                      component={ FieldGenerico }                      
                      label="Ubicación en Bod. Principal:"/>
                  </div>
                </Row>
                <Row isInvisible={(this.state.operacion==='G')}>
                  <div className='col-md-12'>
                    <Label>Artículos que puede sustituir:</Label>
                    <AgGridRender altura='100px' data={articulosSustituibles} columnas={this.state.columnDefs} 
                      gridOptions={this.gridOptions} onGridReady={this.onGridReady}/>
                  </div>
                </Row>
                <Row>               
                  <div className='col-md-12'>
                    <div className="btn-group pull-right">
                      <button type="submit" className='btn btn-primary btn-sm' disabled={submitting}>
                        <i className="fa fa-floppy-o fa-lg"></i> {this.state.operacion==='G'?' Guardar':' Modificar'}
                      </button>
                      <button type="button" className='btn btn-sm' onClick={this.inicializarComponentes}>
                        <i className="fa fa-trash-o fa-lg"></i> Limpiar
                      </button>
                    </div>
                  </div>
                </Row>
              </form>
            </CuerpoForm>
          </ContenedorForm>
      );
  }
}

const selector = formValueSelector('form_inven01');

FormInven01 = reduxForm({
  form: 'form_inven01', enableReinitialize: true, validate
})(FormInven01);

FormInven01 = connect(
  state => ({
    initialValues: state.inicializacion_form.data,
    codigo_articulo: selector(state, 'articulo'),
    codigo_arancel: selector(state, 'arancel'),    
    permiso: state.sesion.valoresSesionForm.Permiso,
    idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
    articuloValues: getFormValues('form_inven01')(state)
  }),
  { cargar_Articulo, cargar_ValoresIniciales, generar_LogAuditoriaIngresoForm,
    generar_LogAuditoriaSalidaForm, cambiar_VisualizacionLoading, cambiarArancelDeArticulo }
)(FormInven01);

export default FormInven01;